import { Grade10CourseOverviewData } from "../../data/OSSDOverviewData/Grade10CourseOverviewData";
import Grade from "../../components/CourseComp/Grade";

export default function GradeTenOverviewPage() {
    return (
        <div>
            <Grade data={Grade10CourseOverviewData} />
        </div>
    )
}